import React from 'react';
import { CommonContactFields } from '../components/CommonContactFields';
import { CommonCreditFields } from '../components/CommonCreditFields';
import { creditFormInitialValues } from '../form';

export const OffsetRetireForm = ({
  control,
  errors,
  register,
  watch,
  reasonMenus,
  selectMenus,
  type,
  selectedMenu,
  validations,
}) => {
  const initialValues = creditFormInitialValues[type];

  return (
    <div className='flex flex-col gap-4'>
      <CommonContactFields
        register={register}
        errors={errors}
        initialValues={initialValues}
        layout='grid'
        validations={validations}
      />
      <CommonCreditFields
        type={type}
        control={control}
        errors={errors}
        register={register}
        watch={watch}
        showAmount={true}
        showProjectSeq={true}
        selectMenus={selectMenus}
        selectedMenu={selectedMenu}
        reasonMenus={reasonMenus}
        validations={validations}
      />
    </div>
  );
};
